// Internal
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  setSubChildId,
  prefixCurriculumName,
} from "Administrator/modules/AdministratorModule";
import { getSelectedCurriculumId } from "modules/CommonSelectors";

// Relative
import IncludeExcludeSubjects from "./routes/IncludeExcludeSubjects";
import DefineAddedValue from "./routes/DefineAddedValue";

// Constants
import { GPA_SETUP } from "Constants/stringConstants";

export default store => ({
  path: "gpa-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-academicSetup-gpaAndCredits" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = getSelectedCurriculumId(state);
    const subChildId = store.dispatch(
      prefixCurriculumName({
        childId: GPA_SETUP,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(subChildId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [IncludeExcludeSubjects(store), DefineAddedValue(store)],
});
